// Saga for Notification

import { call, put, all, takeEvery } from "redux-saga/effects";

import {
  GET_NOTIFICATION_OPEN_LIST,
  SYSTEM_NOTIFICATION_INTERNAL_SEND,
} from "./actionType";

import {
  getNotificationOpenListSuccess,
  getNotificationOpenListError,
  systemNotificationInternalSendSuccess,
  systemNotificationInternalSendError,
} from "./action";

import {
  getNotificationOpenListApiCall,
  systemNotificationInternalSendApiCall,
} from "../../helpers/fakebackend_helper";

// get notification Open List
function* getNotificationOpenListSaga() {
  try {
    const response = yield call(getNotificationOpenListApiCall);
    yield put(getNotificationOpenListSuccess(response));
  } catch (error) {
    yield put(getNotificationOpenListError(error));
  }
}

export function* watchGetNotificationOpenListSaga() {
  yield takeEvery(GET_NOTIFICATION_OPEN_LIST, getNotificationOpenListSaga);
}
// system notification internal send
function* systemNotificationInternalSendSaga({ payload }) {
  try {
    const response = yield call(systemNotificationInternalSendApiCall, payload);
    yield put(systemNotificationInternalSendSuccess(response));
  } catch (error) {
    yield put(systemNotificationInternalSendError(error));
  }
}
export function* watchSystemNotificationInternalSendSaga() {
  yield takeEvery(
    SYSTEM_NOTIFICATION_INTERNAL_SEND,
    systemNotificationInternalSendSaga
  );
}

function* Notification() {
  yield all([
    watchGetNotificationOpenListSaga(),
    watchSystemNotificationInternalSendSaga(),
  ]);
}

export default Notification;
